import { useEffect, useState } from 'react';
import { IntegrationAppProvider } from '@membranehq/react';
import { ListIntegrationAppConnections } from './ListIntegrationAppConnections';
import useAuthedRequest from 'src/hooks/useAuthedRequest';

export const ListIntegrationAppConnectionsProvider = () => {
  const [token, setToken] = useState('');
  const { get } = useAuthedRequest();

  const getIntegrationAppToken = async () => {
    const response = await get('/account-connections/integration-app/token');

    if (response.token) setToken(response.token);
  };

  useEffect(() => {
    getIntegrationAppToken();
  }, []);

  return (
    <IntegrationAppProvider token={token}>
      <ListIntegrationAppConnections isLoading={!token} />
    </IntegrationAppProvider>
  );
};
